import React, { ReactNode } from "react";

import cn from "classnames";

import styles from "./RecordCount.module.scss";

interface Props {
  actions?: ReactNode;
  className?: string;
  count: ReactNode;
}

const RecordCount = ({ actions, className, count }: Props) => {
  return (
    <div className={styles.container}>
      <div className={cn(styles.count, className)}>{count}</div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
};

export default RecordCount;
